import React from 'react';
import { providerName } from '../../../../utils';
import RadioGroup from '../../../BuildingBlocks/Form/RadioGroup';
import Header from '../../../BuildingBlocks/Headers/BoldHeader';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  container: {
    marginBottom: theme.spacing(4.5),
  },
}));

export default function BankQuestions({ setValue, useWatch, control }) {
  const classes = useStyles();
  const questions = {
    yes: {
      id: 'yes',
      text: 'I will connect my bank account on the next screen.',
    },
    no: {
      id: 'no',
      text: 'I’m unable to connect my bank account and/or would like to speak with customer service.',
    },
  };
  return (
    <div className={classes.container}>
      <Header>
        There is no bank account associated with your {providerName} account.
      </Header>
      <RadioGroup
        groupId="willConnectBank"
        options={Object.values(questions)}
        setValue={setValue}
        useWatch={useWatch}
        control={control}
      />
    </div>
  );
}
